import { initDocument } from '../initializers/document.js';
import { updateOrAddToArray } from '../languageExtensions/array.js';
import 'lodash-unified';

/**
 * Given an existing documents array, returns a documents array with a new
 * document added. If a document of the same type already exists in the array,
 * the first one found will be replaced.
 */

const addOrReplaceDocumentByType = (documents, file, type, info) => {
  const newDocument = initDocument(file, type, info);
  const newDocuments = updateOrAddToArray(documents, document => document.type === type, () => newDocument);
  return newDocuments;
};

export { addOrReplaceDocumentByType };
